import React from "react";

export default function NewHeroSection() {
  return (
    <section
      className="bg-cover bg-center text-white overflow-hidden rounded-3xl pt-16"
      style={{
        backgroundImage:
          "url('/assests/images/LandingPage/hero-section-background.webp')",
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20 lg:py-24">
        {/* Left Side Content */}
        <div className="text-center md:text-left">
          {/* Tagline Block */}
          <div className="inline-flex flex-col md:inline-block bg-gray-100 text-gray-800 text-sm font-medium pr-3 py-2 rounded-full mb-6 shadow-sm">
            <span className=" text-white bg-black rounded-full px-4 py-1.5 mb-1 font-semibold text-xs sm:text-sm">
              What's New?
            </span>
            <span className="text-xs sm:text-sm px-2">
              Now Manage your OOH Campaigns virtually
            </span>
          </div>

          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black leading-tight mb-4">
            Transform your way of <br />
            retail store signage execution
          </h2>

          {/* Paragraph */}
          <p className="text-gray-700 text-sm sm:text-base mb-6">
            World’s first platform to help Brands manage their OOH Campaigns by
            extending reach and minimising time.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <button className="bg-blue-500 text-white px-6 py-2 rounded-full font-medium shadow-md hover:bg-blue-600 transition">
              Start as Brand
            </button>
            <button className="bg-black text-white px-6 py-2 rounded-full font-medium border hover:bg-white hover:text-black transition">
              Contact Sales
            </button>
          </div>
        </div>

        {/* Right Side Visual */}
        <div className="relative w-full flex justify-center md:justify-end mt-10 md:mt-0">
          <img
            src="/assests/images/LandingPage/hero-section-img.webp"
            alt="Hero Main"
            className="w-10/12 sm:w-full h-auto object-contain"
          />
          <img
            src="/assests/images/LandingPage/hero-section1.1.webp"
            alt="Floating Icon"
            className="absolute bottom-10 sm:bottom-24 -left-1 sm:-left-12 animate-bounce w-12 sm:w-24 h-auto"
          />
        </div>
      </div>
    </section>
  );
}
